/*
 * Copyright (c) 2017-2021. Code réalisé par IpsoSenso.
 */

import { GET_USER_SUCCESS, LOGIN_SUCCESS, LOGOUT_SUCCESS, TOKEN_REFRESH } from './loginActions'
import {removeGoogleToken, removeLocalUser as removeLocalUserApi} from './loginApi'

const loginReducer = () => {
	const initialState = {
		authenticated: false
	}

	return (state = initialState, action = {}) => {
		switch (action.type) {
			case LOGIN_SUCCESS:
			case TOKEN_REFRESH:
				return {
					...state,
					token: action.token,
					authenticated: true
				}
			case GET_USER_SUCCESS: {
				const user = action.user
				return {
					...state,
					...user
				}
			}
			case LOGOUT_SUCCESS:
				removeGoogleToken()
				removeLocalUserApi()
				return {}
			default:
				return state
		}
	}
}

export default loginReducer
